import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { processSteps } from "@/mocks/testimonials";

export default function Process() {
  return (
    <section className="w-full bg-foreground-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-300 uppercase">
              <span className="w-6 h-px bg-accent-400"></span>
              审核流程
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
              从一条线索，到一次有回应的发酵
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-200/90 leading-relaxed">
              我们不做“收到即发布”的堆料站。每一条爆料都要经过脱敏、初判与交叉核实，才会被推到台前。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {processSteps.map((step, index) => (
            <Reveal key={step.step} delay={index * 90}>
              <div className="relative h-full pl-5 border-l border-background-50/20">
                <span className="font-heading text-3xl md:text-4xl font-bold text-accent-400">
                  {step.step}
                </span>
                <h3 className="mt-3 font-heading text-lg font-semibold text-background-50">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm text-background-200/90 leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}